import { axios } from '../utils/http';
import { log } from '../utils/common';

async function downloadFile(link, filename) {
  try {
    log('downloadApi::downloadFile');
    const headers = {
      responseType: 'blob',
    };

    const { data } = await axios.get(link + '?time='+ new Date(), headers);
    if (window.navigator.appVersion.toString().indexOf('.NET') > 0) {
      window.navigator.msSaveBlob(data, filename);
    } else {
      const url = window.URL.createObjectURL(new Blob([data]));
      const downloadLink = document.createElement('a');
      downloadLink.href = url;
      downloadLink.setAttribute('download', filename);
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  } catch (e) {
    // eslint-disable-next-line no-alert
    alert('처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.');
  }
}

export default {
  downloadFile,
};
